module.exports = __webpack_public_path__ + "static/img/3.06287de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/3.png
// module id = 2QcI
// module chunks = 0